import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  belongsTo() {
    return faker.lorem.words(3);
  },

  name() {
    return faker.name.firstName();
  },

  shortName() {
    return this.name.substring('3');
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },
});
